module.exports = __webpack_public_path__ + "static/media/py.13233f64.svg";